<template>
    <v-container class="mainContainer">
        <ConfirmPortfolioWithdrawal
            :showConfirmDialog="showConfirmDialog"
            :lenderPercentage="getReturns"
            :key="showConfirmDialog"
            @closeDialog="closeDialog"
            @confirmWithdrawal="sendWithdrawalRequest"
        />
        <div class="backButton" style="padding: 16px;" v-if="step < 7 && step !== 6">
            <v-icon class="material-icons-round" @click="goBack"> arrow_back </v-icon>
        </div>
        <div v-if="step === 1" style="width: 100%;">
            <LockInOver/>
            <div class="activeButton" v-if="isActiveWithdrawal" style="padding: 16px 16px 0px;">
                <button class="activeWithdrawButton forhove" @click="showActiveWithdrawals()">
                    History
                    <div class="right-chevron"></div>
                </button>
            </div>
            <div class="container-2 border" style="padding: 16px;">
                <div class="heading">
                    Portfolio Withdrawal
                </div>
                <div v-for="(portfolio, index) in portfolios" :key="index" >
                    <PortfolioCard :portfolio="portfolio" screen="upcoming" @withdrawPortfolio="withdrawPortfolio" @withdrawLocked="withdrawLocked" :activeExpansion="activeExpansion" @showEmptyState="showEmptyState" :index="index" @expandTransactions="expandTransactions"/>
                </div>
                <div class="emptyState" v-if="isEmptyState === portfolios.length">
                    <img src="/img/withdraw_portfolio_empty.svg" alt="">
                    <span class="spanText-1">
                        Currently you do not have any portfolio for withdrawal
                    </span>
                    <span class="spanText-2">
                        <router-link to="/select-plan">
                            Start Investing
                        </router-link>
                    </span>
                </div>
            </div>
        </div>
        <ViewWithdrawalTransactions v-else-if="step === 2" :selectedPortfolio="selectedPortfolio" @withdrawPortfolio="viewSummary"/>
        <WithdrawalSummary v-else-if="step === 3" :selectedPortfolio="selectedPortfolio" @confirmWithdrawPortfolio="confirmWithdrawPortfolio"/>
        <WithdrawalOptions  style="padding: 16px !important;" v-else-if="step === 4" :selectedPortfolio="selectedPortfolio"  :withdrawalAmount="withdrawableAmount" :unlockedAmount="unlockedAmount" @confirmWithdrawalOption="confirmWithdrawalOption"/>
        <PartialWithdrawal  style="padding: 16px !important;" v-else-if="step === 5 && withdrawalOption === 'partial'" :withdrawType="withdrawType" :portfolio="selectedPortfolio" :withdrawalAmount="withdrawableAmount" @sendWithdrawalRequest="partialWithdrawalRequest" @goForward="step++"/>
        <RequestSubmitted   style="padding: 16px !important;" v-else-if="step === 6"/>
        <ActiveWithdrawals  style="padding: 16px !important;" v-else-if="step === 7" @goBack="goBack"/>
        <div class="footnote" style="padding: 16px;" v-if="step < 7 && step !== 6">
            Read
                <a href="https://www.indiap2p.com/faqs" target="_blank">
                    Withdrawal FAQs
                </a>
            for smooth process.
        </div>
    </v-container>
</template>

<script>
import LockInOver from '@/components/withdrawal/lockInOver.vue'
import PortfolioCard from '@/components/withdrawal/portfolioCard.vue'
import WithdrawalSummary from '@/components/withdrawal/withdrawalSummary.vue'
import WithdrawalOptions from '@/components/withdrawal/withdrawalOptions.vue'
import PartialWithdrawal from '@/components/withdrawal/partialWithdrawal.vue'
import RequestSubmitted from '@/components/withdrawal/requestSubmitted.vue'
import ActiveWithdrawals from '@/components/withdrawal/activeWithdrawals.vue'
import ConfirmPortfolioWithdrawal from '@/components/withdrawal/confirmWithdrawalDialog.vue'

import LenderService from '@/services/lenderService'
import ViewWithdrawalTransactions from '../components/withdrawal/viewWithdrawalTransactions.vue'

export default {
    name: 'WithdrawPortfolio',
    components: {
        LockInOver,
        PortfolioCard,
        WithdrawalSummary,
        WithdrawalOptions,
        PartialWithdrawal,
        RequestSubmitted,
        ActiveWithdrawals,
        ConfirmPortfolioWithdrawal,
        ViewWithdrawalTransactions
    },
    data () {
        return {
            step: 1,
            portfolios: [],
            selectedPortfolio: null,
            selectedPortfolioId: null,
            withdrawableAmount: 0,
            unlockedAmount: 0,
            withdrawalOption: null,
            withdrawType: 'partial',
            selectedAmount: 0,
            activeExpansion: null,
            lenderPercentage: 0,
            isActiveWithdrawal: false,
            showConfirmDialog: false,
            isEmptyState: false
        }
    },
    mounted () {
        this.getWithdrawalPortfolios()
        this.checkActiveWithdrawal()
    },
    computed: {
        getReturns () {
            if (this.selectedPortfolio) {
                // if (this.selectedPortfolio.totalEarnings) {
                //     return (100 * this.selectedPortfolio?.totalEarnings / this.withdrawableAmount).toFixed(2)
                // }
                return this.lenderPercentage
            }
            return 0
        }
    },
    methods: {
        getWithdrawalPortfolios () {
            this.$store.commit('isLoading', { message: 'We are calculating your withdrawal amount!' })
            LenderService.getWithdrawalPortfolios().then((response) => {
                if (response.status === 404) {
                    this.isEmptyState = 0
                } else {
                    this.portfolios = response.data.result
                    if (!this.portfolios.length) {
                        this.isEmptyState = this.portfolios.length
                    }
                }
                this.$store.commit('isNotLoading')
            })
        },
        checkActiveWithdrawal () {
            LenderService.checkActiveWithdrawal().then((response) => {
                if (response.status === 200) {
                    this.isActiveWithdrawal = response.data.isActiveWithdrawal
                }
            })
        },
        withdrawPortfolio (portfolio) {
            this.selectedPortfolio = portfolio
            this.step = 2
        },
        viewSummary () {
            this.step = 3
        },
        withdrawLocked (portfolio) {
            this.selectedPortfolio = portfolio
            this.selectedPortfolioId = portfolio.portfolioId
            this.withdrawType = 'locked'
            const queryString = 'portfolioId=' + this.selectedPortfolio.portfolioId + '&type=locked'
            this.$store.commit('isLoading')
            LenderService.getWithdrawalSummary(queryString).then((response) => {
                this.portfolio = response.data.portfolio
                this.withdrawableAmount = response.data.withdrawableAmount
                this.withdrawalOption = 'partial'
                this.step = 4
                this.$store.commit('isNotLoading')
            })
        },
        goBack () {
            if (this.step === 7) {
                this.step = 1
            } else if (this.step === 5 && this.withdrawType === 'locked') {
                this.step = 1
            } else if (this.step > 1) {
                this.step--
            } else {
                this.$router.push({ path: '/settings' })
            }
        },
        confirmWithdrawPortfolio (portfolio, withdrawableAmount) {
            this.selectedPortfolioId = this.selectedPortfolio.portfolioId
            this.withdrawableAmount = withdrawableAmount
            this.unlockedAmount = portfolio.unlockedAmount
            this.lenderPercentage = portfolio.lenderPercentage
            this.step++
        },
        confirmWithdrawalOption (option) {
            this.withdrawalOption = option
            if (this.withdrawalOption === 'full') {
                this.selectedAmount = this.withdrawableAmount
                this.showConfirmDialog = true
            } else if (this.withdrawalOption === 'unallocated') {
                this.selectedAmount = this.selectedPortfolio.unallocatedAmount
                this.showConfirmDialog = true
            } else {
                this.step++
            }
        },
        partialWithdrawalRequest (amount, option) {
            this.withdrawalOption = option
            this.selectedAmount = amount
            this.showConfirmDialog = true
        },
        sendWithdrawalRequest () {
            const payload = {
                portfolioId: this.selectedPortfolioId,
                withdrawalAmount: this.selectedAmount / 100,
                withdrawalType: this.withdrawalOption,
                type: this.withdrawType
            }
            this.$store.commit('isLoading')
            LenderService.sendPortfolioWithdrawalRequest(payload).then((response) => {
                if (this.withdrawalOption === 'full' || this.withdrawalOption === 'unallocated') {
                    this.step = 6
                } else {
                    this.step++
                }
                this.$store.commit('isNotLoading')
            })
            this.closeDialog()
        },
        showActiveWithdrawals () {
            this.step = 7
        },
        expandTransactions (value) {
            this.activeExpansion = value
        },
        closeDialog () {
            this.showConfirmDialog = false
        },
        showEmptyState () {
            this.isEmptyState++
        }
    }
}
</script>

<style lang="scss" scoped>

    .mainContainer {
        height: 100%;
    }

    @media (min-width: 990px) {
        .mainContainer {
            width: 40%;
            position: relative;
            padding-top: 100px !important;

            // display: flex;
            // flex-direction: column;
            // justify-content: center;
            // height: 100%;
        }

        .backButton {
            position: absolute;
            left: -72px;
            top: 14px;
            width: 50px !important;
        }

    }

    .backButton {
        width: 100%;
        padding: 12px 0px;
    }

    .heading {
        font-weight: 600;
        font-size: 17px;
        line-height: 21px;
        color: #232323;
        margin-bottom: 26px;
        margin-top: 12px;
    }

    .activeButton {
        margin-top: 12px;
        margin-bottom: 32px;
    }

    .activeWithdrawButton {
        display: flex;
        flex-direction: row;
        width: 100%;
        padding: 11px 24px;
        gap: 10px;
        align-items: center;
        justify-content: space-between;
        border: 1.5px solid #002FA7;
        border-radius: 6px;
        color: #002FA7;
        letter-spacing: 0.005em;
        font-size: 14px;
        line-height: 150%;
        font-weight: 600;
    }

    .right-chevron {
        background-image: url(/img/chevron-right.svg);
        width: 18px;
        height: 18px;
        background-size: contain;
    }

    .forhove {
        &:hover {
            background-color: #002Fa7;
            color: white !important;
            .dashboard-title {
                color: #000000 !important;
            }
            .v-icon.v-icon {
                color: white !important;
            }

            .right-chevron {
                filter: invert(100%) sepia(99%) saturate(0%) hue-rotate(290deg) brightness(109%) contrast(100%);
            }
            .plan-text {
                color: #000000 !important;
            }
        }
    }

    .v-icon.v-icon.fa-chevron-right{
        color: #002FA7;
    }

    .emptyState {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .spanText-1 {
        color: #9E9E9E;
        font-size: 12px;
        padding: 12px;
        width: 248px;
        text-align: center;
    }

    .spanText-2 {
        color: #007AFF;
        font-size: 12px;
        text-decoration-line: underline;
    }

    .container {
        padding: unset !important;
    }

    .footnote {
        text-align: right;
        letter-spacing: 0.2px;
        font-style: italic;
        font-weight: 400;
        font-size: 12px;
        color: #202B3C;
    }
    // .border {
    //     background: #FFFFFF;
    //     border: 1px solid #002FA7;
    // }
</style>
